import { Route, Routes } from 'react-router-dom';
import Shell from '../components/layout/Shell';
import Dashboard from '../features/dashboard/Dashboard';
import Products from '../features/products/Products';
import ProductForm from '../features/products/ProductForm';
import ProductDetail from '../features/products/ProductDetail';
import Orders from '../features/orders/Orders';
import OrderDetail from '../features/orders/OrderDetail';
import Customers from '../features/customers/Customers';
import CustomerDetail from '../features/customers/CustomerDetail';
import Inventory from '../features/inventory/Inventory';
import Coupons from '../features/coupons/Coupons';
import Reviews from '../features/reviews/Reviews';
import NotificationsPage from '../features/notifications/NotificationsPage';
import Settings from '../features/settings/Settings';
import Categories from '../features/categories/Categories';
import Colors from '../features/colors/Colors';
import Sizes from '../features/sizes/Sizes';
import Login from '../features/auth/Login';
import Unauthorized from '../features/auth/Unauthorized';
import { ProtectedRoute } from '../features/auth/ProtectedRoute';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      
      {/* Protected admin routes */}
      <Route element={<ProtectedRoute requireAdmin={true} />}>
        <Route element={<Shell />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/new" element={<ProductForm />} />
          <Route path="/products/:id/edit" element={<ProductForm key="edit" />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:id" element={<OrderDetail />} />
          <Route path="/customers" element={<Customers />} />
          <Route path="/customers/:id" element={<CustomerDetail />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/colors" element={<Colors />} />
          <Route path="/sizes" element={<Sizes />} />
        </Route>
      </Route>
    </Routes>
  );
}

